module.exports = __webpack_public_path__ + "img/flags/CC.9b5f975.png";